import { render } from "./OffenseTable.vue?vue&type=template&id=89590db8&lang=true"
import script from "./OffenseTable.vue?vue&type=script&lang=js"
export * from "./OffenseTable.vue?vue&type=script&lang=js"
script.render = render

export default script